<div class="px-3">
  <ng-container>
    <div class="row mb-3">
      <div class="col">
        <h2>
          <em class="fas fa-dolly pe-2"></em>
          {{ 'Abteilung wählen' | translate }}
        </h2>
      </div>
      <div class="col-auto">
        <button mat-icon-button color="warn" (click)="cancel()">
          <em class="fas fa-times fa-1_5x"></em>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <input
          #searchInput
          class="form-control"
          [placeholder]="'Abteilung suchen' | translate"
          (input)="search$.next(searchInput.value)"
          />
      </div>
    </div>

    @if (departments && departments.length) {
      <div class="row mb-2">
        <div class="col">
          <ul class="list-group" data-cy="DEPARTMENT_SELECTION_SINGLE">
            @for (department of departments | orderBy: 'name'; track department) {
              <li
                class="list-group-item hoverable cursor-pointer"
                [class.active]="selectDepartment === department"
                (click)="selectDepartment(department)"
                >
                <div class="col">
                  <div
                    class="row mx-auto font-08 align-items-center"
                    [class.font-07]="department?.name.length > 25"
                    [class.font-08]="department?.name.length < 25"
                    >
                    <strong class="m-0">
                      {{ department.name }}
                    </strong>
                  </div>
                </div>
              </li>
            }
          </ul>
        </div>
      </div>
    }
    <div class="row justify-content-end sticky-buttons">
      <div class="col-md-auto col-sm-12 mb-1">
        <button class="btn btn-secondary w-100" (click)="cancel()">{{ 'Abbrechen' | translate }}</button>
      </div>
      <div class="col-md-auto col-sm-12 mb-1">
        <button data-cy="SAVE_SIMPLE" class="btn btn-primary w-100" (click)="save()">
          {{ 'Auswählen' | translate }}
        </button>
      </div>
    </div>
  </ng-container>
</div>
